import { DebtDto } from '../../pages/users/api/dto/get/DebtDto'
import { DebtsDto } from '../../pages/users/api/dto/get/DebtsDto'
import { DebtsUI } from '../../pages/users/model/DebtsUI'
import Debt from './Debt'

class Debts {
  private constructor(total: number, debts: Debt[]) {
    this.total = total
    this.debts = debts
  }

  private readonly total: number
  private readonly debts: Debt[]

  toDebtsUI(): DebtsUI {
    return {
      totalDebt: this.total,
      debts: this.debts.map((debt: Debt) => debt.toDebtUI()),
    } satisfies DebtsUI
  }

  static fromDto(debtsDto: DebtsDto): Debts {
    const { total, debts } = debtsDto

    return new Debts(
      total,
      debts.map((debt: DebtDto) => Debt.fromDto(debt)),
    )
  }
}

export default Debts
